module.exports = __webpack_public_path__ + "img/upload-s2.84c4a672.svg";